module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO07_01ActividadPresentacio.eba142a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO07_01ActividadPresentacio.mp4
// module id = 735
// module chunks = 1